// TODO: get rid of ErrorBoundary component usage.
import React from 'react';
import ErrorBoundary from '@/components/ErrorBoundary';
import { MainSideBar } from '@/components/MainSideBar';
import { UpgradeNow } from '@/components/UpgradeNow';
import sidebarMenu from '@/css/module/sidebarMenu.css';

export const AppWithLimitedAccess = () => (
  <div className={sidebarMenu.pageContainer}>
    <ErrorBoundary>
      <MainSideBar />
    </ErrorBoundary>
    <div className={sidebarMenu.content}>
      <ErrorBoundary>
        <UpgradeNow />
      </ErrorBoundary>
    </div>
  </div>
);
